import { render, staticRenderFns } from "./tab4.vue?vue&type=template&id=904b961a&"
import script from "./tab4.vue?vue&type=script&lang=js&"
export * from "./tab4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports